import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import articleImg from "../../assets/article8.png"
import ArticleContent from "../../components/sections/blog/ArticleContent";
import { articleContent8 } from "../../constants/data";
import RequestDemo from "../../components/common/RequestDemo";

const ArticleFourth = ({title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-[2.25rem] sm:gap-16 lg:gap-0">
      <HeroReuse
        Title="What is Global Regulatory Compliance?"
        Description="Learn everything you need to know about global regulatory compliance, including what it is, why it matters, common challenges, and how RegTechFlow can help your team stay ahead."
        date="7 Aug 2025"
        imgUrl={articleImg}
        titleClass={'tracking-tight pt-3 md:pt-8'}
      />
      <ArticleContent content={articleContent8} toolsClass="font-bold text-darkGray"/>
      <RequestDemo />
    </div>
  );
};

export default ArticleFourth;
